import type { BellSchedule, Lesson } from 'services/api';

export const getLessonBellTime = (
  lessonIndex: Lesson,
  currentBellSchedule: BellSchedule | null,
): string => {
  if (!currentBellSchedule) return ' - ';

  const currentLessonBell = currentBellSchedule.bells.find(
    (bell) => bell.lessonIndex === lessonIndex,
  );
  return currentLessonBell
    ? `${currentLessonBell.startTime} - ${currentLessonBell.endTime}`
    : ' - ';
};
